import { CustomLoadingService } from './../../shared/custom-loading/custom-loading.service';
import { AuthenticationService } from './../authentication.service';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-activate-user',
  templateUrl: './activate-user.component.html',
  styleUrls: ['./activate-user.component.css']
})
export class ActivateUserComponent implements OnInit {
  message = "";
  token: any = "";
  constructor(private route: ActivatedRoute, private service: AuthenticationService, private loaderService: CustomLoadingService) { }

  ngOnInit(): void {

    this.token = this.route.snapshot.params.token;
    this.activateUser();
  }
  activateUser() {
    this.loaderService.show();
    this.service.activateUser(this.token).subscribe(res => {
      if (res.status == 1) {
        this.message = "Your Account is Activated Successfully"
      }
      else if (res.status == 2) {

        this.message = "Your Account is already Activated";
      }
      else {
        this.message = "Unexpected error. Please try after sometime"
      }


    }, (error) => {

      this.message = "Unexpected error. Please try after sometime"
      this.loaderService.show();

    }, () => {
      this.loaderService.show();

    })

  }
}

